export const API_ENDPOINT = 'task';


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/endpoints.js